import SiteLayout from '@/components/feature/SiteLayout';
import Seo from '@/components/feature/Seo';
import HeroSection from '@/pages/home/components/HeroSection';
import LiveTicker from '@/pages/home/components/LiveTicker';
import NewsBoard from '@/pages/home/components/NewsBoard';
import TopicShowcase from '@/pages/home/components/TopicShowcase';
import CategoryGrid from '@/pages/home/components/CategoryGrid';
import MediaTracking from '@/pages/home/components/MediaTracking';
import Testimonials from '@/pages/home/components/Testimonials';
import NewsletterCta from '@/pages/home/components/NewsletterCta';

const homeSchema = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '网报吃瓜',
    description:
      '网报吃瓜聚合最新热点快讯、媒体报道与转载动态，按时间线梳理事件起因、扩散路径与各方报道差异。',
    inLanguage: 'zh-CN',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: `${window.location.origin}/topics?keyword={search_term_string}`,
      },
      'query-input': 'required name=search_term_string',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '网报吃瓜',
    description: '专注热点脉络的中文资讯聚合站，按时间线整理快讯、媒体报道与转载动态。',
    email: 'contact@wangbaochigua.com',
  },
];

function Home() {
  return (
    <SiteLayout>
      <Seo
        title="网报吃瓜 - 网报吃瓜快讯实时刷不停，媒体报道与转载全程跟踪"
        description="网报吃瓜聚合最新热点快讯、媒体报道与转载动态，按时间线梳理事件起因、扩散路径与各方报道差异，让你一屏看尽网报吃瓜资讯与新闻脉络。"
        keywords="网报吃瓜,网报吃瓜快讯,网报吃瓜媒体,网报吃瓜报道,网报吃瓜转载,网报吃瓜资讯,网报吃瓜新闻"
        canonicalPath="/"
        schema={homeSchema}
      />
      <HeroSection />
      <LiveTicker />
      <NewsBoard />
      <TopicShowcase />
      <CategoryGrid />
      <MediaTracking />
      <Testimonials />
      <NewsletterCta />
    </SiteLayout>
  );
}

export default Home;